module.exports = __webpack_public_path__ + "img/about-04.c2968efe.jpeg";